export default {
    state: {
        homeschoolStore: false,
    },
    getters: {
        isHomeschoolStore: (state) => {
            return state.homeschoolStore;
        }
    },
    mutations: {
        setHomeschoolStore(state, v) {
            state.homeschoolStore = v;
        }
    },
    actions: {
        async setAsHomeschoolStore(context, v) {
            context.commit('setHomeschoolStore', v);
            context.commit('setProducts', []);

            // When enabling homeschool mode, force National
            const targetState =  'NA';

            await context.dispatch('getStateData', {state: targetState});
        },
    }
}
